/**
 * Single source of truth for portfolio-agent configuration.
 *
 * Update the values in this file to point at real destinations on the
 * Framer portfolio. All client tools and postMessage handlers resolve
 * user-supplied identifiers through the allow-lists declared here, so
 * arbitrary URLs / DOM selectors can never reach the parent page.
 */

// ElevenLabs agent (public agent, no signed URL needed)
export const AGENT_ID = "agent_2701m10g8nw5eec80qzjx5m7ke5c";

// Backend origin for signed-URL / WebRTC-token minting
export const BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL || "";

// Greeting the agent speaks the moment a voice session connects.
// Set to null to fall back to the agent's server-side firstMessage.
export const VOICE_FIRST_MESSAGE =
  "Hi, I'm Pinky, Preeti's portfolio twin. Ask me anything about her work, projects, or design approach — I'm all ears.";

// Parent-page origin allow-list for postMessage
export const ALLOWED_PARENT_ORIGINS = [
  "https://preetyux.work",
  "https://www.preetyux.work",
  "http://preetyux.work",
];

// Project ID -> case-study URL on preetyux.work
export const PROJECTS = {
  absorb: {
    id: "absorb",
    title: "Absorb Case study",
    url: "https://preetyux.work/absorb",
    thumbnail: "/assets/absorb.webp",
  },
  omnee: {
    id: "omnee",
    title: "Omnee Case study",
    url: "https://preetyux.work/omnee",
    thumbnail: "/assets/omnee.webp",
  },
  manulife: {
    id: "manulife",
    title: "Manulife Case study",
    url: "https://preetyux.work/manulife",
    thumbnail: "/assets/manulife.webp",
  },
};

// navigate_to destination -> URL / hash on preetyux.work
export const NAV_DESTINATIONS = {
  home: "https://preetyux.work/",
  about: "https://preetyux.work/#about",
  work: "https://preetyux.work/#work",
  contact: "https://preetyux.work/#connect",
  connect: "https://preetyux.work/#connect",
};

// scroll_to_section allow-list (values are the hash fragments on the Framer page)
export const SECTION_IDS = {
  about: "about",
  work: "work",
  connect: "connect",
  contact: "connect",
  process: "process",
  hero: "hero",
};

// External destinations
export const RESUME_URL = "https://preetyux.work/cv_preetishah/cv_preeti-shah_2026.pdf";
export const LINKEDIN_URL = "https://www.linkedin.com/in/preeti25/";
export const CONTACT_URL = "https://preetyux.work/#connect";

// Suggested prompts shown in the empty state
export const SUGGESTED_PROMPTS = [
  "Show me your CV",
  "What impact did your work have?",
];

// Intro / first message rendered before any conversation starts
export const INTRO_MESSAGE =
  "I am Pinky, Preeti's portfolio twin...\n\nAsk me anything about her work or experience and I'll do my best to answer!";

export const AVATAR_URL = "/assets/avatar.png";

export function resolveProject(projectId) {
  if (!projectId || typeof projectId !== "string") return null;
  return PROJECTS[projectId.toLowerCase().trim()] || null;
}

export function resolveDestination(destination) {
  if (!destination || typeof destination !== "string") return null;
  return NAV_DESTINATIONS[destination.toLowerCase().trim()] || null;
}

export function resolveSection(sectionId) {
  if (!sectionId || typeof sectionId !== "string") return null;
  return SECTION_IDS[sectionId.toLowerCase().trim()] || null;
}
